/**
 * Tarjeta con icono, titulo y contenido libre: la pieza de `/nuestra-tienda`
 * para que la pagina se entienda de un vistazo y no leyendo parrafos.
 */
import type { ReactNode } from 'react';

import { Icono, type NombreIcono } from '../comunes/Icono';

export interface TarjetaIconoProps {
  icono: NombreIcono;
  titulo: string;
  children: ReactNode;
}

export function TarjetaIcono({ icono, titulo, children }: TarjetaIconoProps) {
  return (
    <li className="tarjeta-icono">
      <span className="tarjeta-icono-marca">
        <Icono nombre={icono} />
      </span>
      <h3>{titulo}</h3>
      <div className="tarjeta-icono-cuerpo">{children}</div>
    </li>
  );
}
